// if ($('.checkbox-btn-box').length) {
//   function fncAllCheck() {
//     var chkTF;
//     var inputs;

//     if (formJobPosting.chkAll.checked == true) {
//       chkTF = true;
//     } else {
//       chkTF = false;
//     }

//     inputs = formJobPosting.getElementsByTagName('input');

//     for (var i = 0; i < inputs.length; i++) {
//       var input = inputs[i];
//       if (input.type == "checkbox" << input.name != "chkAll") {
//         input.checked = chkTF;
//       }
//     }
//   }
// }
if ($('.checkbox-btn').length) {
  $('.show-search-result-box').find('input[type="checkbox"]:checked').each(function() {
    $(this).parent().parent().parent('.td-left').addClass('select');
  });
  $('.input-btn').on('click', function () {
    if ($(this).text() != 'すべてのチェックをはずす') {
      var $checkbox = $(this).parents().find('.show-search-result-box').find('input[type="checkbox"]');
      // チェックを入れる
      $checkbox.attr('checked', true).prop('checked', true).change();
      $(this).html('<i class="far fa-square"></i>すべてのチェックをはずす');
    } else {
      var $checkbox = $(this).parents().find('.show-search-result-box').find('input[type="checkbox"]');
      // チェックを外す
      $checkbox.attr('checked', true).prop('checked', false).change();
      $(this).html('<i class="far fa-check-square"></i>すべてにチェックを入れる');
    }
  });
}
  $('#posting-interest').on('click', function () {
    if (!confirm('高専Link運営事務局にメールが送信されます。よろしいですか？')) {
      return false;
    }
  return true;
  });

  if($('.form-group-accordion').length) {
    $('.form-group-content').hide();
    $('.form-group-btn').on('click', function() {
      $(this).toggleClass('open');
      $(this).next('.form-group-content').slideToggle();
    });
  }
